import { fetchToken } from "../../../common/FetchCookie";

const API = "https://api.indiahirings.com/api/profile/send-verification-email"

export const sendVerificationEmail = async () => {
  try {
    const token = await fetchToken();
    const response = await fetch(`${API}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to send verification email");
    }

    return await response.json();
  } catch (error) {
    throw new Error(error.message);
  }
};

const API_URL = "https://api.indiahirings.com/api/profile/verify-email"; // Replace with actual API endpoint

export const getEmailVerifiedStatus = async (token) => {
  try {
    const AuthToken = await fetchToken()

    const response = await fetch(`${API_URL}/${token}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${AuthToken}`
      },
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to fetch password reset status");
    }

    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};

